import { YEARLY_MAX_COMPLIMENTARY_15 } from '../../../contracts/yearly-max-complimentary-discount';
import type { ComplimentaryYearlyMaxOffer } from '../../settings/use-complimentary-yearly-max-offer';
import {
  type ClinicianTrialEndGates,
  useClinicianTrialEndState,
} from './use-clinician-trial-end-state';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Days the offer stays open after the trial ends. Must match the window the backend accepts the coupon in. */
export const CLINICIAN_TRIAL_ENDED_OFFER_GRACE_DAYS = 7;

/**
 * The yearly Max offer for a new user's Clinician trial: it runs to the trial
 * end, then for the grace window after it. `isOfferEnabled` stays off until
 * the backend accepts the coupon for trial members.
 */
export function useClinicianTrialYearlyMaxOffer({
  isOfferEnabled,
  ...gates
}: ClinicianTrialEndGates & {
  isOfferEnabled: boolean;
}): ComplimentaryYearlyMaxOffer | null {
  const trialEnd = useClinicianTrialEndState(gates);
  if (!isOfferEnabled || trialEnd == null) return null;
  if (trialEnd.phase !== 'ended') {
    return {
      cycleEnd: trialEnd.trialEnd,
      applyDiscountForYearlyMax: YEARLY_MAX_COMPLIMENTARY_15,
    };
  }

  const offerEnd =
    Date.parse(trialEnd.trialEnd) + CLINICIAN_TRIAL_ENDED_OFFER_GRACE_DAYS * MS_PER_DAY;
  if (Date.now() >= offerEnd) return null;
  return {
    cycleEnd: new Date(offerEnd).toISOString(),
    applyDiscountForYearlyMax: YEARLY_MAX_COMPLIMENTARY_15,
  };
}
